import React from 'react';
import { HeroUIProvider as Provider } from '@heroui/react';
import { ToastProvider } from '@heroui/toast';

interface HeroUIProviderProps {
  children: React.ReactNode;
}

export const HeroUIProvider: React.FC<HeroUIProviderProps> = ({ children }) => {
  return (
    <Provider>
      <ToastProvider />
      {children}
    </Provider>
  );
};

HeroUIProvider.displayName = 'HeroUIProvider';